export default class FSA {
    public data = {
        type: null,
        payload: null,
        meta: null,
        error: null
    };

    constructor(private type: string) {
        this.data.type = type;
    }

    addMeta(meta) {
        this.data.meta = meta;
        return this;
    }

    addPayload(payload) {
        this.data.payload = payload;
        return this;
    }

    addError(error) {
        this.data.error = true;
        this.data.payload = error;
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/actions/FSA.ts